var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"score"},[_c('h3',{staticClass:"score-label"},[_c('span',{staticClass:"score-label--text"},[_vm._v("SCORE")]),_c('span',{staticClass:"score-label--number"},[_vm._v(" "+_vm._s(_vm.score)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }